const debug = false;
const initialMin = 40;
const initialMax = 140;

class BpmChart {

    constructor(el, options) {
        if(debug) {
            console.log('BpmChart: init in element with id \''+el+'\'', options);
        }

        this.container = document.getElementById(el);
        if(!this.container) {
            console.error('BpmChart: element with id \''+el+'\' not found', this.container);
            return;
        }

        this.options = options;

        const { data = [], fromDate, toDate, animation = true, showLine = false, fill = false, stepSize } = options;

        this.fromDate = new Date(fromDate ?? '');
        this.toDate = new Date(toDate ?? '');
        this.stepSize = stepSize;

        // console.debug(fromDate, toDate, this.fromDate, this.toDate, this.fromDate.getTime(), this.toDate.getTime())

        this.container.className = "chart-container";
        this.canvas = document.createElement("canvas");
        this.canvas.id = el+'_canvas';
        // this.canvas.height = this.maxY * 6.5;
        // this.canvas.style = "margin-right: 45px;";

        const ctx = this.canvas.getContext("2d");

        // COLORS
        const color1 = 'rgb(255, 11, 65)';
        const color1Op = 'rgba(255, 11, 65, 0.2)';
        const color1Tr = 'rgba(255, 11, 65, 0)';
        //const color1Ov = 'rgb(255, 11, 65)';
        const colorBPMAlert = 'rgb(255, 94, 0)';


        const backgroundGradient = ctx.createLinearGradient(0, 0, 0, 450);
        backgroundGradient.addColorStop(0.7, color1Tr);
        backgroundGradient.addColorStop(0, color1Op);

        this.container.appendChild(this.canvas);

        if(debug) {
            console.debug('BpmChart data', data);
        }

        this.convertData(data);

        this.chart = new Chart(this.canvas.id, {
            type: 'line',
            data: {
                labels: this.getLabels(),// this.labels,
                datasets: [{
                    borderColor: (data) => {
                        if(data.type == 'data') {
                            if(
                                (this.options?.thresholds?.minValue && parseFloat(data.raw?.y) < parseFloat(this.options.thresholds.minValue))  ||
                                (this.options?.thresholds?.maxValue && parseFloat(data.raw?.y) > parseFloat(this.options.thresholds.maxValue)) 
                            ){
                                return colorBPMAlert;
                            }
                        }

                        return color1;
                    },
                    borderWidth: 2,
                    radius: 3,
                    pointBackgroundColor: 'white',
                    data: this.data,
                    backgroundColor: backgroundGradient,
                    tension: 0,
                    // pointHoverBorderWidth: 0,
                    fill,
                    showLine
                }]
            },
            options: {
                layout: {
                    padding: {
                        top: 25,
                    //     left: -10,
                    //     bottom: -10
                    }
                },
                animation: animation,
                interaction: {
                    intersect: false,
                    mode: 'index'
                },
                plugins: {
                    legend: false,
                    tooltip: {
                        displayColors: false,
                        position: 'nearest',
                        callbacks: {
                            title: function(tooltipItems) {
                                return moment(tooltipItems[0].raw.x).format('DD/MM/YYYY HH:mm');
                            },
                            label: function(tooltipItem) {
                                // console.log('tooltip', tooltipItem);
                                return 'BPM: '+tooltipItem.raw.y;
                            },
                        }
                    },
                },
                scales: {
                    x: {
                        type: 'linear',
                        min: this.fromDate ? this.fromDate.getTime() : null,
                        max: this.toDate ? this.toDate.getTime() :  null,
                        grid: {
                            borderWidth: 0,
                            color: function(line) {
                                return false;
                            }
                        },
                        ticks: {
                            display: true,
                            stepSize: this.getStepSize(),
                            // color: '#999',
                            font: {
                                size: 12,
                            },
                            callback: (val, index) => {
                                // Hide the label of every 2nd dataset
                                // return index % 2 === 0 ? moment(this.getLabelForValue(val)).format('DD/MM HH:mm') : '';
                                return this.labels ? moment(val).format(this.getLabelFormat()) : null;
                            },
                        },
                    },
                    y: {
                        type: 'linear',
                        min: initialMin,
                        max: initialMax,
                        grid: {
                            borderWidth: 0,
                            borderDash: [4],
                            color: function(line) {
                                return "rgba(75,75,75,0.2)";
                            }
                        },
                        ticks: {
                            display: true, //this will remove only the label
                            stepSize: 1,
                            color: color1,
                            font: {
                                size: 12,
                            },
                            callback: function(value, index) {
                                return value + '  ';
                            }
                        },
                    },
                },
                responsive: true,
                maintainAspectRatio: true
            },
            plugins: [
                {
                    afterDatasetDraw: (chart) => {
                        let ctx = chart.ctx;
                        ctx.font = '12px Arial';
                        ctx.textBaseline = 'top';
                        ctx.textAlign = 'left';
                
                        ctx.fillStyle = color1;
                        ctx.fillText('BPM', 24, 0);
                    }
                }
            ]
        });

        this.autoScaling();

        this.chart.update();

        if(debug) {
            console.debug('BpmChart done', this.labels, this.data);
        }
    }

    convertData(data) {
        // this.labels = [];
        this.data = [];

        if(!!data && !!data.value) {
            for (const prop in data.value) {
                // console.log(`${prop} - ${data.value[prop]}`);
                // this.labels.push(prop);
                let millis = parseInt(prop) * 1000;
                this.data.push({
                    y: data.value[prop],
                    x: millis
                });
            }
        }

        if(debug) {
            console.debug('BpmChart convertData', this.labels, this.data);
        }

        // if(this.labels.length == 0) {
        //     this.setDefaultLabels()
        // }
    }

    // setDefaultLabels() {
    //     var days = 14;
    //     var date = moment().subtract(days - 1, 'd');
    //     for(var i = 0; i < days; i++) {
    //         // console.debug(date);
    //         this.labels.push(date.format('YYYY-MM-DD HH:mm:ss'));
    //         date = date.add(1, 'day');
    //     }
    // }

    setData(data, fromDate, toDate) {
        if(debug) {
            console.debug('BpmChart setData', this.chart, this.chart.scales, fromDate, toDate);
        }

        this.fromDate = new Date(fromDate);
        this.toDate = new Date(toDate);

        this.chart.config.options.scales.x.min = this.fromDate.getTime();
        this.chart.config.options.scales.x.max = this.toDate.getTime();
        this.chart.config.options.scales.x.ticks.stepSize = this.getStepSize();
        this.convertData(data);

        // if(!this.checkNewData(data)) {
        //     if(debug) {
        //         console.debug('ignoring data. same array');
        //     }

        //     return;
        // }

        this.chart.data.labels = this.getLabels();
        this.chart.data.datasets[0].data = this.data;

        this.autoScaling();

        this.chart.update();

        if(debug) {
            console.debug('BpmChart done', this.labels, this.data);
        }
    }

    autoScaling() {
        if(debug) {
            console.log('BpmChart setData start cycle', this.data, this.data.length);
        }

        let min = initialMin;
        let max = initialMax;

        for(let i=0; i < this.data.length; i++) {
            if(this.data[i] == null) {
                continue;
            }

            const value = parseFloat(this.data[i].y);

            let newMax = Math.ceil((value + 20) / 10) * 10;
            if(debug) {
                console.debug('BpmChart setData test newMax', value, newMax, max);
            }
            if(max < newMax) {
                max = newMax;
            }

            let newMin = Math.trunc((value - 20) / 10) * 10;
            if(newMin < 0) {
                newMin = 0;
            }

            if(debug) {
                console.debug('BpmChart setData test newMin', value, newMin, min);
            }
            if(min > newMin) {
                min = newMin;
            }
        }
        
        if(debug) {
            console.log('BpmChart setData min max', min, max);
        }

        this.chart.options.scales.y.min = min;
        this.chart.options.scales.y.max = max;
    }

    getLabels() {
        let date = new Date(this.fromDate);
        let labels = [];
        // let debugs = [];

        while(date <= this.toDate) {
            labels.push(date.getTime());
            // date.setDate(date.getDate() + 1);
            date = new Date(date.getTime() + this.getStepSize());
            // debugs.push(moment(date.getTime()).format('DD/MM/YYYY HH:mm'));
        }

        // console.debug('labels', debugs);
        this.labels = labels;

        return labels;
    }

    getStepSize() {
        if(!this.stepSize) {
            this.stepSize = this.toDate - this.fromDate > 604800000 ? 86400000 : 900000;
        }

        return this.stepSize;
    }

    setDateRange(fromDate, toDate) {
        if(debug) {
            console.log('setting dateRange', fromDate, toDate);
        }

        this.fromDate = new Date(fromDate ?? '');
        this.toDate = new Date(toDate ?? '');

        this.chart.config.options.scales.x.min = this.fromDate.getTime();
        this.chart.config.options.scales.x.max = this.toDate.getTime();

        if(debug) {
            console.log('setDateRange: updating chart');
        }

        this.chart.update();

        if(debug) {
            console.log('setDateRange: updated');
        }
    }

    setStepSize(stepSize) {
        this.stepSize = stepSize;

        this.chart.config.options.scales.x.ticks.stepSize = stepSize;

        if(debug) {
            console.log('setStepSize: updating chart');
        }

        this.chart.update();

        if(debug) {
            console.log('setStepSize: updated');
        }
    }

    getLabelFormat() {
        // console.debug('getLabelFormat', this.fromDate, this.toDate, this.toDate - this.fromDate, 604800000 + 86400000, this.toDate - this.fromDate > 604800000 + 86400000);
        return this.toDate - this.fromDate > 604800000 + 86400000 ? 'DD/MM/YYYY' : 'DD/MM HH:mm';
    }

    toBase64Image(type, quality) {
        return this.chart.toBase64Image(type, quality);
    }
}

window.BpmChart = BpmChart;